import { tns } from 'tiny-slider/src/tiny-slider';
import ModalDefault from './modal-default';
import EqualHeight from '../util/equal-height';

class EpisodeSlider {
	constructor(el, loadingSpinner) {
		this.el = el;
		this.loadingSpinner = loadingSpinner;
		this.slidesPerView = parseInt(this.el.dataset.slidesPerView, 10)
			? parseInt(this.el.dataset.slidesPerView, 10)
			: 3;
		this.showing = this.el.dataset.showing ? this.el.dataset.showing : null;
		this.topic = this.el.dataset.topic ? this.el.dataset.topic : null;
		this.dataSource = this.el.dataset.source ? this.el.dataset.source : null;
		this.displayType = this.el.dataset.displayType ? this.el.dataset.displayType : null;

		this.instances = {
			modals: [],
			equalHeight: [],
			slider: null
		};

		// this.generateSlides();
		// this.buildManualSlider();
		this.makeSliderButtons();
		this.buildSlider();
	}

	buildSlider = () => {
		const EpisodeSlider = tns({
			container: this.el,
			responsive: {
				350: {
					items: 1
				},
				500: {
					items: 2
				},
				900: {
					items: 2
				}
			},
			autoplay: true,
			autoplayButtonOutput: false,
			// mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			gutter: 30,
			nav: false
		});

		this.instances.slider = EpisodeSlider;
		this.sliderControls();

		return EpisodeSlider;
	};

	buildManualSlider = () => {
		if (this.dataSource === 'manual') {
			this.buildSlider();
			this.generateModals();
			this.equalizeHeights();
			this.loadingSpinner.style.display = 'none';
		}
	};

	fetchSlides = () => {
		let endpoint = '/wp-json/wp/v2/film-meta?show_all';

		if (window.location.pathname.includes('independentlens')) {
			endpoint = '/independentlens/wp-json/wp/v2/film-meta?show_all';
		}

		// Update endpoint for staging site
		if (window.location.pathname.includes('independentlens')) {
			endpoint = '/independentlens/wp-json/wp/v2/film-meta?show_all';
		}
		const queryParams = [];
		if (this.showing) {
			queryParams.push(`showing=${this.showing}`);
		}
		if (this.topic) {
			queryParams.push(`topic=${this.topic}`);
		}

		if (queryParams.length > 0) {
			endpoint += '&' + queryParams.join('&');
		}

		const data = fetch(endpoint)
			.then((response) => response.json())
			.then((res) => res)
			.catch((error) => console.error('Error:', error));
		return data;
	};

	generateSlides = async () => {
		if (this.dataSource === 'taxonomy') {
			const data = await this.fetchSlides();
			const slides = data.films.slice(0, 30);

			if (slides.length > 0) {
				let slideMarkup = '';
				slides.forEach((slide) => {
					if (this.displayType === 'cards') {
						slideMarkup += slide.slider_card_markup;
					} else {
						slideMarkup += slide.slider_poster_markup;
					}
				});
				this.el.innerHTML += slideMarkup;
			}
			this.buildSlider();
			this.generateModals();
			this.equalizeHeights();
			this.loadingSpinner.style.display = 'none';
		}
	};

	sliderControls = () => {
		this.el.addEventListener('mouseenter', () => {
			this.instances.slider.pause();
		});

		this.el.addEventListener('mouseleave', () => {
			this.instances.slider.play();
		});

		document.addEventListener('keyup', (e) => {
			e.preventDefault();
			if (e.key === 'ArrowRight') {
				this.instances.slider.goTo('next');
			}
			if (e.key === 'ArrowLeft') {
				this.instances.slider.goTo('prev');
			}
		});
	};

	makeSliderButtons = () => {
		// Create custom buttons dynamically
		const prevButton = document.createElement('button');
		prevButton.innerHTML = `
		<div class="slider-icon-container">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M15 18l-6-6 6-6"></path>
			</svg>
    </div>
  `;
		prevButton.setAttribute('aria-label', 'Previous Slide');
		prevButton.className = 'custom-prev';

		const nextButton = document.createElement('button');
		nextButton.innerHTML = `
		<div class="slider-icon-container">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M9 18l6-6-6-6"></path>
			</svg>
    </div>
  `;
		nextButton.setAttribute('aria-label', 'Next Slide');
		nextButton.className = 'custom-next';

		this.prevButton = prevButton;
		this.nextButton = nextButton;

		// Append buttons to the parent of the slider container
		this.el.parentElement.appendChild(prevButton);
		this.el.parentElement.appendChild(nextButton);
	}

	generateModals = () => {
		Array.from(this.el.querySelectorAll('.js__modal--default')).forEach((modalDefaultEl) => {
			this.instances.modals.push(new ModalDefault(modalDefaultEl));
		});
	};

	equalizeHeights = () => {
		this.instances.equalHeight.push(new EqualHeight(this.el));
	};
}

export default EpisodeSlider;
